import React from 'react';
import { lmsProviderConfig } from '@/components/shared/Lms/lmsProviders';
import { LmsIconKind } from '@/components/shared/Lms/types';

interface LmsButtonProps {
  children: ReactChildren;
  disabled?: boolean;
  handleClick: () => void;
  lmsKind: LmsIconKind | null;
}

const LmsButton = ({
  children, disabled, handleClick, lmsKind,
}: LmsButtonProps) => {
  const provider = lmsKind ? lmsProviderConfig(lmsKind) : null;

  return (
    <div>
      <button
        className="dropdown-item tw-cursor-pointer tw-w-full"
        disabled={disabled}
        type="button"
        onClick={handleClick}
      >
        <div className="tw-flex tw-items-center">
          {provider && <img alt={`Connected to ${provider.name}`} src={provider.logo} width="20" />}

          <span className="ml5">
            {children}
          </span>
        </div>
      </button>
    </div>
  );
};

export default LmsButton;
